import { DateTimeField, TextAreaInput, TextField, TextFieldInputProps } from "@hex-insights/forms";
import { StudentVaccinationRecordFormValues } from "../../FormUtilities";
import { BaseFieldProps } from "../shared";
import { StudentSelectField } from "../Student";
import { VaccineSelectField } from "../Vaccine";

/**
 * Generic props for fields of the StudentVaccinationRecord model.
 */
type FieldProps<
	K extends keyof StudentVaccinationRecordFormValues.Base = keyof StudentVaccinationRecordFormValues.Base,
> = BaseFieldProps<Pick<StudentVaccinationRecordFormValues.Base, K>>;

/**
 * Field component for the `receivedOn` field of the StudentVaccinationRecord model.
 */
export function ReceivedOn({ formState, ...props }: FieldProps<"receivedOn">) {
	return <DateTimeField formState={formState} name="receivedOn" precision="day" {...props} />;
}

/**
 * Field component for the `notes` field of the StudentVaccinationRecord model.
 */
export function Notes({ formState, ...props }: FieldProps<"notes">) {
	return <TextField formState={formState} name="notes" multiLine optional Input={NotesInput} {...props} />;
}

function NotesInput(props: TextFieldInputProps) {
	return <TextAreaInput minRows={2} {...props} />;
}

export namespace Student {
	export type SelectProps = FieldProps<"studentID"> &
		Omit<StudentSelectField.SelectProps<StudentVaccinationRecordFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `student` edge of the StudentVaccinationRecord model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <StudentSelectField.Select formState={formState} name="studentID" {...props} />;
	}
}

export namespace Vaccine {
	export type SelectProps = FieldProps<"vaccineID"> &
		Omit<VaccineSelectField.SelectProps<StudentVaccinationRecordFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `vaccine` edge of the StudentVaccinationRecord model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <VaccineSelectField.Select formState={formState} name="vaccineID" {...props} />;
	}
}
